import { ButtonBase, styled as muiStyled } from '@mui/material'

export const PharmacyDatabaseForm = muiStyled('form')(
  ({ theme }) => `
    
`,
)
export const PharmcyPageContainer = muiStyled('div')(
  ({ theme }) => `
    padding: 30px 30px 15px 30px;
        display: flex;
    flex-direction: column;
    gap: 20px;
`,
)

export const PharmacyTableContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
    width: 100%;
    max-height: 600px;
    
    gap: 10px;
`,
)

export const PharmacySearchContainer = muiStyled('div')(
  ({ theme }) => `
    max-width: 500px;
`,
)

export const PharmacySaveButton = muiStyled(ButtonBase)(
  ({ theme, disabled }) => `
  position: relative;
    display: flex;
    justify-content:center;
    align-items: center;
    padding: 7px 13px;
    gap:7px;
    border-radius: 10px;
    background: ${disabled ? '#D9D9D9' : '#6e63c4'};
    color: white;
    &:hover{
      background-color: ${disabled ? '#D9D9D9' : '#6e71c1'};
    }
    transition: all 150ms ease-in-out;
  `,
)

export const DeleteDrugButton = muiStyled(ButtonBase)(
  ({ theme, disabled }) => `
  position: relative;
    display: flex;
    justify-content:center;
    align-items: center;
    padding: 7px 13px;
    gap:7px;
    border-radius: 10px;
    background: ${disabled ? '#D9D9D9' : '#c46363'};
    color: white;
    &:hover{
      background-color: ${disabled ? '#D9D9D9' : '#c16e6e'};
    }
    transition: all 150ms ease-in-out;
  `,
)
